export default function TagFilter({tags, activeTag, onChange}) {
    return (
        <div className="tag-filter">
            <button
                type="button"
                className={activeTag === null ? 'chip active' : 'chip'}
                onClick={() => onChange(null)}
            >
                Toutes
            </button>

            {tags.map(tag => (
                <button
                    key={tag}
                    type="button"
                    className={activeTag === tag ? 'chip active' : 'chip'}
                    onClick={() => onChange(tag)}
                >
                    {tag}
                </button>
            ))}
        </div>
    );
}
